export default __webpack_public_path__ + "static/exterior1-e29a2b5b7ed72a7553755b8681e52f3d.jpg";